
import * as actions from '../actionType/ActionTypes'

export const setCategoryData = data => {
    return {
        type : actions.SET_CATEGORY_DATA,
        payload : data
    }
}
export const setAllCategory = data => {
    return {
        type : actions.SET_ALL_CATEGORY,
        payload : data
    }
}

export const rightBarOpen = (rightbarType, id) => {
    return {
        type : actions.RIGHTBAR_OPEN,
        payload : [rightbarType, id]
    }
}

export const rightBarClose = () => {
    return {
        type : actions.RIGHTBAR_CLOSE
    }
}

export const setNotifyCountFn = () => {
    return {
        type : actions.NOTIFY_COUNT
    }
}

export const searchDataStore = payload => {
    return {
        type : actions.SEARCH_DATA,
        payload : payload
    }
}

export const searchResultStore = payload => {
    return {
        type : actions.SEARCH_RESULT,
        payload : payload
    }
}
export const searchStateFn = payload => {
    return {
        type : actions.SEARCH_STATE,
        payload : payload
    }
}
export const searchTrigger = payload => {
    return {
        type : actions.SEARCH_TRIGGER,
        payload : payload
    }
}
export const archiveTrigger = () => {
    return {
        type : actions.ARCHIVE_TRIGGER
    }
}


export const setPendingCountFn = payload => {
    return {
        type : actions.PENDING_COUNT,
        payload : payload
    }
}

